import { Box } from '@lemonade-hq/cdk';
import styled from 'styled-components';

export const IMAGE_STICK_TO_RIGHT_BREAKPOINT = 1670;

export const LottieContainer = styled(Box)`
  height: 493px;
  position: relative;

  svg {
    min-width: 781px;
    height: 493px;
    position: absolute;
    bottom: -7px;
    left: -1px;

    @media (min-width: ${IMAGE_STICK_TO_RIGHT_BREAKPOINT}px) {
      left: auto;
      right: -169px;
    }
  }
`;
